import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';

export class EmptyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    // do not show key while translations are loading
    return '';
  }
}
